import React, { FC, useCallback } from 'react';

import styled from 'styled-components';

import { EUIThemedButtonIconTextOpacity } from '@aquariuxfintech/aqx-trader-react-ui/button';
import { ESpacing, ETypography } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

import { EDataTestId } from '@aqx-core/common/data-test-id/types';
import { rgba } from '@aqx-core/common/theme/utils';

interface IAuthResendTextProps {
  $marginTop: ESpacing;
  descriptionText: string;
  actionText: string;
  onClickResend: () => void;
  isResendDisabled: boolean;
  remainingTimeText: string;
}

const AuthResendText: FC<IAuthResendTextProps> = ({
  $marginTop,
  descriptionText,
  actionText,
  onClickResend,
  isResendDisabled,
  remainingTimeText
}) => {
  const onClickResendHandler = useCallback(() => {
    if (!isResendDisabled) {
      onClickResend();
    }
  }, [isResendDisabled, onClickResend]);

  return (
    <StyledText typography={ETypography.TEXT_L_REGULAR} $marginTop={$marginTop}>
      {descriptionText}{' '}
      <StyledResendContainer onClick={onClickResendHandler} data-testid={EDataTestId.SIGN_UP_RESEND_VERIFICATION}>
        <StyledResendText $isDisabled={isResendDisabled} typography={ETypography.TEXT_L_MEDIUM}>
          {actionText}
        </StyledResendText>
      </StyledResendContainer>{' '}
      <StyledTimerText>{remainingTimeText}</StyledTimerText>
    </StyledText>
  );
};

export default AuthResendText;

const StyledText = styled(UIText)<{ $marginTop: ESpacing }>`
  color: ${({ theme }) => theme.themeColors.text.subtle};
  margin-top: ${({ $marginTop }) => $marginTop}px;
`;

const StyledResendContainer = styled.span``;

const StyledResendText = styled(UIText)<{ $isDisabled: boolean }>`
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};

  color: ${({ theme, $isDisabled }) =>
    rgba(theme.themeColors.primary, $isDisabled ? EUIThemedButtonIconTextOpacity.DISABLED : 1)};
  display: inline;
`;

const StyledTimerText = styled.span`
  color: ${({ theme }) => theme.themeColors.primary};
`;
